import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { useState } from "react";
import FormConfiguraciones from "../components/form-configuraciones";
import useModal from "../../../../core/hooks/use-modal";

const Configuraciones = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalConfiguracion = useModal({
        title: "Agregar Configuración",
        data: { configuracion: {}, tipo: "crear" },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];
    if (userCan("nominaCrearConfiguracion")) {
        tableButtons.push({
            titleAttr: "Agregar Configuración",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalConfiguracion.open({
                    title: "Agregar Configuracion",
                    data: { configuracion: {}, tipo: "crear" },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("nominaEditarConfiguracion")) {
        tableButtons.push({
            titleAttr: "Editar Configuración",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;
                modalConfiguracion.open({
                    title: "Editar Configuración",
                    data: { configuracion: data, tipo: "editar" },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("actualizarNominaConfiguracion")) {
        tableButtons.push({
            titleAttr: "Actualizar Configuración",
            text: '<i class="fas fa-highlighter"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalConfiguracion.open({
                    title: "Actualizar Configuración",
                    data: { configuracion: data, tipo: "actualizar" },
                });
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "Configuraciones",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tableConfiguraciones",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/configuraciones`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listdo de las configuraciones"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "valor" },
            { data: "tipo" },
            { data: "codigo" },
        ],
        columnDefs: [
            {
                targets: [3],
                createdCell: function (td, cellData) {
                    td.textContent =
                        cellData == 1
                            ? "Número"
                            : cellData == 2
                            ? "Porcentaje"
                            : cellData == 3
                            ? "Texto"
                            : "Hora";
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Configuraciones
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tableConfiguraciones"
                >
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">Valor</th>
                            <th className="text-center text-white">Tipo</th>
                            <th className="text-center text-white">Codigo</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormConfiguraciones
                modalState={modalConfiguracion}
                onSave={onSave}
            />
        </ContentWrapper>
    );
};

export default Configuraciones;
